(function () {
  'use strict';

  angular.module('app').service('PackagePriceModalService', PackagePriceModalService);

  PackagePriceModalService.$inject = ['ModalService'];

  function PackagePriceModalService(ModalService) {
    var service = {
      openSuggestedPackagePricesModal: openSuggestedPackagePricesModal,
    };

    return service;

    ////////////////

    // --------------------------- openSuggestedPackagePricesModal -------------------------

    function openSuggestedPackagePricesModal(data, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/package-prices/modals/suggested-package-prices-modal.html',
        controller: SuggestedPackagePricesModalCtrl,
        controllerAs: 'vm',
        inputs: {
          data: data,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        var preventModalClose = {
          backdrop: 'static',
          keyboard: false,
        };

        modal.element.modal(preventModalClose);
      });

      SuggestedPackagePricesModalCtrl.$inject = [
        'UtilService',
        'CONFIGURATIONS',
        'data',
        'PackagePriceService',
      ];
    }

    function SuggestedPackagePricesModalCtrl(
      UtilService,
      CONFIGURATIONS,
      data,
      PackagePriceService
    ) {
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.hourDisplay = CONFIGURATIONS.HOUR_DISPLAY; // Ex: 01:00 PM

      vm.package = data.package;
      vm.season = data.season;
      vm.priceList = data.priceList;
      vm.paxRange = data.paxRange;

      // Initializers
      searchSuggestedPackagePrices();

      function searchSuggestedPackagePrices() {
        var filterCriteria = {
          by_pax_range: vm.paxRange.id,
          by_price_list: vm.priceList.id,
          by_season: vm.season.id,
        };

        vm.suggestedPackagePrices = null;
        vm.loadingSuggestedPackagePrices = true;
        PackagePriceService.searchSuggestedPackagePrices(vm.package, filterCriteria).then(function (
          data
        ) {
          vm.suggestedPackagePrices = data;

          vm.totalAdultPrice = vm.totalChildPrice = vm.totalInfantPrice = vm.totalSeniorPrice = 0;
          vm.totalRoomPrice = vm.totalServicePrice = 0;

          vm.suggestedPackagePrices.forEach(function (item) {
            item.products.forEach(function (product) {
              vm.totalAdultPrice += (product.price && product.price.adult_price) || 0;
              vm.totalChildPrice += (product.price && product.price.child_price) || 0;
              vm.totalInfantPrice += (product.price && product.price.infant_price) || 0;
              vm.totalSeniorPrice += (product.price && product.price.senior_price) || 0;
              vm.totalRoomPrice +=
                (product.price && (product.price.double_price || product.price.single_price)) || 0;
              vm.totalServicePrice += (product.price && product.price.service_price) || 0;
            });
          });

          vm.totalAdultPriceSuggested = 0;
          if (vm.totalAdultPrice) {
            vm.totalAdultPriceSuggested =
              vm.totalRoomPrice / 2 + vm.totalAdultPrice / 2 + vm.totalServicePrice / 2;
          }

          vm.totalChildPriceSuggested = 0;
          if (vm.totalChildPrice) {
            vm.totalChildPriceSuggested =
              vm.totalRoomPrice / 2 + vm.totalChildPrice / 2 + vm.totalServicePrice / 2;
          }

          vm.totalInfantPriceSuggested = 0;
          if (vm.totalInfantPrice) {
            vm.totalInfantPriceSuggested =
              vm.totalRoomPrice / 2 + vm.totalInfantPrice / 2 + vm.totalServicePrice / 2;
          }

          vm.totalSeniorPriceSuggested = 0;
          if (vm.totalSeniorPrice) {
            vm.totalSeniorPriceSuggested =
              vm.totalRoomPrice / 2 + vm.totalSeniorPrice / 2 + vm.totalServicePrice / 2;
          }

          vm.loadingSuggestedPackagePrices = false;

          return data;
        });
      }
    }
  }
})();
